export default "__VITE_ASSET__0nzxNJRb__";